import { TABLE_PROPS } from "@desk/app.constant";
import { SearchForm } from "ui/form";
import { useMessage } from "@desk/hooks/useMessage";
import { useButtonTranslate } from "@desk/hooks/useTranslate";
import { List, useTable } from "@refinedev/antd";
import {
  Avatar,
  Button,
  Card,
  Divider,
  Modal,
  Row,
  Space,
  Switch,
  Table,
  Typography,
} from "antd";
import { CreateButton, DetailButton } from "./components";
import { ExclamationCircleFilled } from "@ant-design/icons";

export const AccountListPage = () => {
  const { tableProps, searchFormProps } = useTable({
    syncWithLocation: true,
  });

  return (
    <List breadcrumb={false} title={false}>
      <Card>
        <Row justify="end" className="mb-4">
          <CreateButton />
        </Row>
        <Table
          {...tableProps}
          {...TABLE_PROPS}
          dataSource={[{}]}
          loading={false}
        >
          <Table.Column
            title="序号"
            dataIndex="name"
            align="center"
            render={(_, __, index) => index + 1}
          />
          <Table.Column title="账号" dataIndex="name" align="center" />
          <Table.Column title="姓名" dataIndex="name" align="center" />
          <Table.Column title="公司名" dataIndex="name" align="center" />
          <Table.Column title="状态" dataIndex="name" align="center" />
          <Table.Column
            title="启用/禁用"
            dataIndex="name"
            align="center"
            render={() => (
              <Switch checkedChildren="启用" unCheckedChildren="禁用" />
            )}
          />
          <Table.Column
            title="操作"
            dataIndex="name"
            render={(_, record) => (
              <Space
                size={0}
                split={
                  <Divider type="vertical" style={{ borderColor: "black" }} />
                }
              >
                <CancelInvitationButton />
                <ResendInvitationButton />
                <RemoveButton />
              </Space>
            )}
          />
        </Table>
      </Card>
    </List>
  );
};

const { Link } = Typography;

const CancelInvitationButton = () => {
  const buttonTranslate = useButtonTranslate();
  const { contextHolder, info } = useMessage();

  const showConfirm = () => {
    Modal.confirm({
      title: "确定取消该管理员的邀请吗？",
      icon: <ExclamationCircleFilled />,
      centered: true,
      onOk() {
        // console.log("OK");
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  };
  return (
    <>
      {contextHolder}
      <Link onClick={showConfirm}>取消邀请</Link>
    </>
  );
};

const ResendInvitationButton = () => {
  const buttonTranslate = useButtonTranslate();
  const { contextHolder, info } = useMessage();

  const showConfirm = () => {
    Modal.confirm({
      title: "确定重发邀请该管理员？",
      icon: <ExclamationCircleFilled />,
      centered: true,
      onOk() {
        // console.log("OK");
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  };
  return (
    <>
      {contextHolder}
      <Link onClick={showConfirm}>重发邀请</Link>
    </>
  );
};

const RemoveButton = () => {
  const buttonTranslate = useButtonTranslate();
  const { contextHolder, info } = useMessage();

  const showConfirm = () => {
    Modal.confirm({
      title: "确定删除该管理员吗？",
      icon: <ExclamationCircleFilled />,
      centered: true,
      onOk() {
        // console.log("OK");
      },
      onCancel() {
        // console.log("Cancel");
      },
    });
  };
  return (
    <>
      {contextHolder}
      <Link type="danger" onClick={showConfirm}>
        {buttonTranslate("delete")}
      </Link>
    </>
  );
};
